import { render, staticRenderFns } from "./VerOrdenPago.vue?vue&type=template&id=19d48cf2&scoped=true&"
import script from "./VerOrdenPago.vue?vue&type=script&lang=js&"
export * from "./VerOrdenPago.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d48cf2",
  null
  
)

export default component.exports